// extracted by mini-css-extract-plugin
module.exports = {"premiumCamCtaContainer":"PremiumCamCTA_premiumCamCtaContainer__DNlaO"};